// extracted by mini-css-extract-plugin
module.exports = {"RatioBar":"RatioBar_RatioBar__5pLN8"};